import { Slot } from '@radix-ui/react-slot'
import * as React from 'react'

import { CheckboxGroupMountedProvider } from './context/CheckboxGroupMounted.context'

type CheckboxGroupSubProps = React.HTMLAttributes<HTMLDivElement> & {
  asChild?: boolean
}

export const CheckboxGroupSub = ({
  asChild = false,
  ...rest
}: CheckboxGroupSubProps): React.JSX.Element => {
  const Component = asChild ? Slot : 'div'

  return (
    <CheckboxGroupMountedProvider>
      <Component {...rest} />
    </CheckboxGroupMountedProvider>
  )
}
